import { Reveal, SectionEyebrow } from "./Reveal";
import { IMAGES, VALUES } from "../../data";

export const About = () => (
  <section id="about" className="bg-white py-20 md:py-28" data-testid="about">
    <div className="container-oyf grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <div className="relative rounded-lg overflow-hidden border-[6px] border-oyf-black dark-shadow">
          <img src={IMAGES.warehouse} alt="Organized dispatch and secure cargo handling operations" className="w-full h-[360px] md:h-[480px] object-cover" />
        </div>
      </Reveal>
      <div>
        <SectionEyebrow>About One York Freight</SectionEyebrow>
        <h2 className="font-display font-extrabold text-oyf-black tracking-tight text-3xl md:text-5xl leading-[1.02]">
          A More Agile Approach to Expedited Logistics
        </h2>
        <div className="mt-5 space-y-4 text-oyf-medgrey text-base md:text-[17px] leading-relaxed">
          <p>One York Freight connects shipment requirements with cargo-van transportation solutions across Canada and the United States. Our focus is on expedited freight, organized dispatch communication and cross-border coordination for businesses that value speed, visibility and professional service.</p>
          <p>By concentrating on cargo vans and Sprinter vans, we help customers access transportation that is appropriately sized for urgent commercial loads without automatically relying on full-size trucking equipment.</p>
          <p>We coordinate the details that keep freight moving: shipment information, equipment suitability, pickup instructions, driver communication, border documentation readiness and delivery follow-up.</p>
        </div>
        <div className="mt-8 grid sm:grid-cols-2 gap-4">
          {VALUES.map((v, i) => (
            <Reveal key={v.t} delay={i * 0.06}>
              <div className="bg-oyf-grey rounded-lg p-5">
                <h3 className="font-display font-bold text-oyf-black">{v.t}</h3>
                <p className="text-sm text-oyf-medgrey mt-1">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
